/** @jsx h */
import { useRef, useEffect } from 'preact/hooks';
import { Fragment } from 'preact';
import { labels } from '../../config';
import ResultTeaser from '../../components/ResultTeaser';
import MapAlternativePagination from './MapAlternativePagination';

const MapAlternative = ({
  searchType,
  highlight,
  list,
  listCount,
  restrictionFilters,
  currentPage,
  setCurrentPage,
  itemsPerPage,
}) => {
  const firstNewResultRef = useRef(null);

  useEffect(() => {
    firstNewResultRef.current?.focus();
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [list]);

  return (
    <section
      className="map-alternative"
      aria-labelledby="map-alternative-heading"
    >
      <span id="map-alternative-heading" className="sr-only">
        {labels.map.alternative.ariaLabel}
      </span>
      {highlight?.length ? (
        <Fragment>
          <h2 className="map-alternative__heading">
            {labels.map.alternative.headingHighlight}
          </h2>
          <div className="main-banderole main-banderole--blue-light main-banderole--no-margin-top main-banderole--no-margin-bottom">
            <div className="main-banderole__inner">
              <div className="main-banderole__content">
                {highlight &&
                  highlight.map((result, index) => (
                    <ResultTeaser
                      key={index}
                      result={result}
                      searchType={searchType}
                      restrictionFilters={restrictionFilters}
                    />
                  ))}
              </div>
            </div>
          </div>
        </Fragment>
      ) : (
        ''
      )}
      {highlight?.length ? (
        <h2 className="map-alternative__heading">
          {labels.map.alternative.headingList}
        </h2>
      ) : (
        ''
      )}
      <ul className="layout-list layout-list--search-results layout-list--no-margin-bottom">
        {list &&
          list.map(
            (result, index) =>
              index < currentPage * itemsPerPage && (
                <li
                  className="layout-list__item"
                  key={index}
                  ref={
                    currentPage > 1 &&
                    index === (currentPage - 1) * itemsPerPage
                      ? firstNewResultRef
                      : undefined
                  }
                  tabIndex={
                    currentPage > 1 &&
                    index === (currentPage - 1) * itemsPerPage
                      ? '-1'
                      : ''
                  }
                >
                  <ResultTeaser
                    result={result}
                    searchType={searchType}
                    restrictionFilters={restrictionFilters}
                  />
                </li>
              )
          )}
      </ul>
      <MapAlternativePagination
        listCount={listCount}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </section>
  );
};

export default MapAlternative;
